export { default } from "./ListTemplateDocuments";
